/** Verifica se o valor informado é um Value Object */
const isValueObject = (value: unknown): value is ValueObject => value instanceof ValueObject;

/**
 * Value Object Abstrato que serve como base para os demais Values Objects da Aplicação
 */
export abstract class ValueObject {
    /** Propriedade do Value Object com erro */
    private _propError: string;
    /** Mensagem de erro do Value Object */
    private _messageError: string;

    /** Seta qual a propriedade do Value Object está com erro */
    protected setPropError(propError: string) {
        this._propError = propError;
    }

    /** Obtem qual a propriedade do Value Object está com erro */
    get propError(): string {
        return this._propError;
    }

    /** Seta a mensagem de erro do Value Object */
    protected setMessageError(messageError: string) {
        this._messageError = messageError;
    }

    /** Obtem a mensagem de erro do Value Object */
    get messageError(): string {
        return this._messageError;
    }

	/** Verifica se o Value Object informado é igual a este Value Object */
	public isEquals(valueObject: ValueObject): boolean {
		if (valueObject == null || valueObject == undefined) {
			return false;
		}

		if (!isValueObject(valueObject)) {
			return false;
		}

		if (this === valueObject) {
			return true;
		}

		return JSON.stringify(this) === JSON.stringify(valueObject);
	}

    /** Verifica se o Value Object está inválido */
    public isValid(): boolean {
        this.setPropError('unknown');
        this.setMessageError('unknown');
        return false;
    }
}
